var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFilterMemberApply(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFilterMemberApply") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 15
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.0%",
    y: "-10.0%",
    width: "120.0%",
    height: "120.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.244367074 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc-Discover-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icFilterMemberApply",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-6-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#7BCB45",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.2198797,5.74088894 C17.1071988,6.97218417 18.4775095,10.2883182 17.3016098,13.1986355 C16.155019,16.0277047 13.0026176,17.4733293 10.1106249,16.4962692 L7.46631128,23.0416033 C7.39795701,23.2098706 7.11758578,23.5280381 6.61313171,23.4037566 C6.10867765,23.279475 6.14825148,22.6366139 6.21596365,22.4680873 L8.86027512,15.9227648 C6.70567883,14.6630183 5.42726459,11.4278418 6.70495,8.6796972 C7.98263541,5.93155261 11.3325607,4.5095937 14.2198797,5.74088894 Z M23.2998621,21.8394027 C23.6915611,21.8394027 23.904136,22.0764286 23.904136,22.3688145 C23.904136,22.6632389 23.6896531,22.8982263 23.2998621,22.8982263 L23.2998621,22.8982263 L12.3063648,22.8982263 C11.9146658,22.8982263 11.7124655,22.6612004 11.7124655,22.3688145 C11.7124655,22.0743901 11.9165738,21.8394027 12.3063648,21.8394027 L12.3063648,21.8394027 Z M23.3653676,18.7688145 C23.6526136,18.7688145 23.8829388,19.0058403 23.8829388,19.2982263 C23.8829388,19.5926507 23.6512144,19.827638 23.3653676,19.827638 L23.3653676,19.827638 L15.082863,19.827638 C14.795617,19.827638 14.5652918,19.5906122 14.5652918,19.2982263 C14.5652918,19.0038018 14.7970162,18.7688145 15.082863,18.7688145 L15.082863,18.7688145 Z M23.3935988,15.6982263 C23.6651768,15.6982263 23.8829388,15.9352521 23.8829388,16.227638 C23.8829388,16.5220624 23.6638539,16.7570498 23.3935988,16.7570498 L23.3935988,16.7570498 L19.2899259,16.7570498 C19.0183479,16.7570498 18.8005859,16.5200239 18.8005859,16.227638 C18.8005859,15.9332136 19.0196708,15.6982263 19.2899259,15.6982263 L19.2899259,15.6982263 Z M8.55534554,7.69444689 C7.2021648,9.07147809 6.81173355,11.1280939 7.56611004,12.9052935 C8.32048653,14.6824931 10.0711085,15.8302858 12.0016601,15.8134553 C13.9322118,15.7966247 15.6625022,14.6184856 16.3856962,12.8284045 C16.8640553,11.6549761 16.8546189,10.3391981 16.3594815,9.1727274 C15.864344,8.00625674 14.9244038,7.0854551 13.748013,6.61442818 C11.9579694,5.8911532 9.90852629,6.31741569 8.55534554,7.69444689 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilterMemberApply);
export default __webpack_public_path__ + "static/media/icFilterMemberApply.f95c1a9c2a2b790febcb9229ae40a1c4.svg";
export { ForwardRef as ReactComponent };